import { useEffect, useState } from "react";

const TableOfContents = ({ articleRef }) => {
  const [headings, setHeadings] = useState([]);
  const [active, setActive] = useState("");

  useEffect(() => {
    if (!articleRef?.current) return;
    const hs = Array.from(articleRef.current.querySelectorAll("h2, h3")).map((el, i) => {
      if (!el.id) {
        const id = (el.textContent || `section-${i}`)
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-+/g, "-")
          .replace(/^-|-$/g, "") + `-${i}`;
        el.id = id;
      }
      return { id: el.id, text: el.textContent || "", level: el.tagName === "H3" ? 3 : 2 };
    });
    setHeadings(hs);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-30% 0px -55% 0px", threshold: 0 }
    );
    hs.forEach((h) => {
      const el = document.getElementById(h.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [articleRef]);

  if (headings.length === 0) return null;

  return (
    <nav data-testid="table-of-contents" aria-label="Table of contents" className="text-sm">
      <p className="eyebrow mb-4">◦  On this page</p>
      <ul className="space-y-2 border-l border-brand-green/15 pl-4">
        {headings.map((h) => (
          <li key={h.id} className={h.level === 3 ? "pl-3" : ""}>
            <a
              href={`#${h.id}`}
              className={`block leading-snug transition ${active === h.id ? "text-brand-teal font-medium" : "text-brand-black/60 hover:text-brand-black"}`}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;
